import { Picture } from "@/components/Picture";
import { Markdown } from "@/components/Markdown";

export const TimelineEntry = ({ entry }) => (
  <li className="tl" data-testid="timeline-entry">
    <time>{entry.date_label}</time>
    <div className={entry.photo ? "tl-body" : "tl-body no-photo"}>
      <div>
        <h3>{entry.title}</h3>
        <Markdown text={entry.body} />
        {entry.link_label && entry.link_url && (
          <p>
            <a href={entry.link_url} rel="noopener">{entry.link_label}</a>
          </p>
        )}
      </div>
      {entry.photo && (
        <figure className={entry.photo_style === "normal" ? undefined : entry.photo_style}>
          <Picture src={entry.photo} alt={entry.photo_alt} lazy />
        </figure>
      )}
    </div>
  </li>
);
